window.onload = function () { 
	let slides = 
		document.getElementsByClassName('carousel-item'); 

    let images = 
        document.getElementsByClassName('img-carousel-item'); 

	function addActive(slide) { 
		slide.classList.add('active'); 
	} 

	function removeActive(slide) { 
		slide.classList.remove('active'); 
	} 

	addActive(slides[0]); 
    addActive(images[0]); 
	setInterval(function () { 
		for (let i = 0; i < slides.length; i++) { 
			if (i + 1 == slides.length) { 
				addActive(slides[0]); 
				setTimeout(removeActive, 100, slides[i]); 
				break; 
			} 
			if (slides[i].classList.contains('active')) { 
				setTimeout(removeActive, 100, slides[i]); 
				addActive(slides[i + 1]); 
				break; 
			} 
		}
        for (let i = 0; i < images.length; i++) { 
			if (i + 1 == images.length) { 
				addActive(images[0]); 
				setTimeout(removeActive, 100, images[i]); 
				break; 
			} 
			if (images[i].classList.contains('active')) { 
				setTimeout(removeActive, 100, images[i]); 
				addActive(images[i + 1]); 
				break; 
			} 
		}
	}, 5000); 
};